// base styles
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";
import typography from "assets/mavric-theme/base/typography";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { text, primary } = colors;
const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: {
      // minWidth: pxToRem(80),
      minHeight: "unset",
      padding: `${pxToRem(4.8)} ${pxToRem(8)}`,
      //borderRadius: borderRadius.md,
      fontSize: size.xs,
      color: text.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: primary.focus,
        color: text.main,
      },

      "&.Mui-disabled":{ opacity: 0.8 }
    },
  },
};

export default menuItem;
